/* Svensk katalog for locale-assets-no.js.
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('sv', {
  "supplierPay.correct": "Korrigera leverant\u00f6rsbetalning",
  "purchaseFlow.subtitle": "Ink\u00f6p, leverant\u00f6rsfakturor och betalningar",
  "purchaseFlow.type": "Typ",
  "supplierPay.settlement": "Betalning",

  "asset.impairmentCancelled": "Annullerad nedskrivning",
  "asset.impairmentCorrectionBlocked": "Select an active impairment with one attributable asset and enter a reason. Correct subsequent asset postings first. Sold and imported assets require review.",
  "asset.correctionEntriesRequired": "The correction requires attributable entries in the same open year, no later than the correction date.",
  "asset.alreadyCancelled": "This acquisition has already been cancelled.",
  "asset.cancelCurrentDate": "Purchase cancellation uses the current accounting reversal date.",
  "asset.cancelWholePurchase": "Select an unsold whole-purchase asset. Mixed purchases require a document-level correction.",
  "asset.cancelSameYear": "Document a correction in the same open acquisition year.",

  'err.purchase.invoiceNumberRequired': 'Ange leverantörens fakturanummer innan du bokför.',
  'err.supplierPayment.reverseUseFirst': 'Återför återbetalning och användning av tillgodobeloppet innan betalningen återförs.',
  'supplierPay.description': 'Betalning av leverantörsfaktura {number}',
  'supplierPay.total': 'Fakturabelopp',
  'supplierPay.paid': 'Betalt / reglerat',
  'supplierPay.remaining': 'Återstår',
  'supplierPay.available': 'Tillgodo hos leverantören',
  'supplierPay.register': 'Registrera betalning',
  'supplierPay.link': 'Koppla befintlig kontering',
  'supplierPay.history': 'Betalningshistorik',
  'supplierPay.selectInvoice': 'Faktura som betalas',
  'supplierPay.noInvoice': 'Ingen faktura vald',
  'supplierPay.overpayment': 'Överskjutande {amount} står kvar som tillgodo hos leverantören.',
  'supplierPay.open': 'Öppna',
  'supplierPay.openTotal': 'Obetalda fakturor',
  'err.asset.reverseSaleBeforeAcquisition': 'Ångra försäljningen innan du ändrar eller makulerar anskaffningen.',
  'asset.tabDrafts': 'Utkast ({n})',
  'asset.bookValueAtSale': 'Bokfört värde på försäljningsdatum',
  'asset.taxDepreciation': 'Skattemässig avskrivning',
  'asset.bookTaxExplanation': 'Det bokförda värdet följer tillgångens avskrivningsplan. Skattevärdet beräknas separat utifrån saldogruppen. Skattesiffrorna gäller hela gruppen när flera tillgångar ingår.',
  'asset.automationActivate': 'Aktivera och bokför',
  'asset.automationCatchUp': 'Kontrollera och bokför utestående',
  'asset.automationPause': 'Pausa automatiken',
  'asset.automationConfirmEnable': 'Bekräfta och bokför',
  'asset.automationConfirmAmount': 'Du godkänner avskrivningsplanerna och bokför {amount} för avslutade månader till och med {date}. Därefter bokförs nya avslutade månader automatiskt.',
  'asset.automationPauseExplanation': 'Framtida automatisk bokföring pausas. Redan bokförda avskrivningar behålls. Avskrivningsbehovet försvinner inte; utestående belopp måste fortfarande bokföras.',
  'asset.automationEnabledSaved': 'Automatiken är godkänd och avslutade månader är bokförda.',
  'asset.automationPausedSaved': 'Automatiken är pausad. Bokförda avskrivningar har behållits.',
  'asset.automationSaveFailed': 'Ändringen kunde inte bekräftas. Kontrollera status innan du försöker igen.',
  'asset.automationPostingNotConfirmed': 'Bokföringen är inte bekräftad. Kontrollera utestående belopp och verifikationer. Utgå inte från att avskrivningarna är bokförda bara för att automatiken är aktiverad.',
  'asset.automationBasisChanged': 'Underlaget har ändrats. Stäng dialogen och kontrollera beloppen på nytt.',
  'asset.automationRequestUncertain': 'Servern svarade inte i tid. Bokföringen kan ha genomförts. Uppdatera bokföringen och kontrollera verifikationerna innan du försöker igen.',
  'asset.automationStatusAwaiting': 'Automatiken är aktiverad. Inga avskrivningar har bokförts än.',
  'asset.postingReviewRequired': 'Måste stämmas av',
  'asset.projectedYearEndValue': 'Beräknat värde vid årets slut (plan)',
  'asset.usefulLifeSuggestionHelp': 'Nyttjandeperioden är ett redigerbart förslag baserat på gruppen. Anpassa efter förväntad användning; det här är ingen skatteregel.',
  'asset.advancedOptions': 'Avancerat',
  'asset.advancedOptionsHelp': 'Anpassa nyttjandeperiod, restvärde eller extra värdeminskning vid behov. Standardvärdena är redan ifyllda.',
  'asset.editAdjustments': 'Anpassa',
  'asset.hideAdjustments': 'Dölj',
  'asset.automaticPlanSummary': 'Nyttjandeperiod: {years} år. Restvärde: {residual}.',
  'asset.noExtraImpairmentDefault': 'Ingen extra nedskrivning som standard.',
  'asset.optionalDocumentation': 'Dokumentation / motivering (valfritt)',
  'asset.title': 'Tillgångar',
  'asset.subtitle': 'Utrustning och värden som företaget äger över tid',
  'asset.new': 'Ny tillgång',
  'asset.info': 'Info',
  'asset.accounting': 'Bokföring',
  'asset.moreActions': 'Fler åtgärder',
  'asset.automationStatusTitle': 'Automatisk månadsbokföring',
  'asset.automationStatusActive': 'Aktiv. Senast bokfört till och med {date}.',
  'asset.automationStatusDefault': 'På som standard. Nya tillgångar bokförs automatiskt varje månad efter registrering.',
  'asset.taxAutomaticTitle': 'Skattemässig avskrivning beräknas automatiskt',
  'asset.taxAutomaticHelp': 'Plumme använder ordinarie skatteregler och föreslår beloppen för {year}. Du behöver normalt inte göra något här.',
  'asset.taxAutomaticDepreciation': 'Beräknad avskrivning',
  'asset.taxAutomaticIncome': 'Beräknad intäktsföring',
  'asset.taxAutomaticDeduction': 'Beräknat förlustavdrag',
  'asset.taxAdvancedChoices': 'Avancerade val',
  'asset.taxAdvancedHelp': 'Använd bara detta när du vill avvika från Plummes förslag eller registrera ingående vinst- och förlustkonto vid systembyte.',
  'asset.changeTaxElection': 'Ändra skattemässigt val',
  'asset.taxElectionCurrentDefault': 'Plummes automatiska förslag för valt saldo är {amount}.',
  'asset.taxElectionOverrideRequired': 'Ange ett belopp som ska avvika från det automatiska förslaget.',
  'asset.taxElectionReasonRequired': 'Skriv varför du åsidosätter det automatiska förslaget.',
  'asset.automationStatusOff': 'Av. Aktivera en gång för att bokföra avslutade månader automatiskt.',
  'asset.automationStatusReview': 'Pausad. Kontrollera planerna och godkänn automatiken på nytt.',
  'asset.automationApprovalNote': 'Godkänd automatisk månatlig bokföring av redovisningsmässiga avskrivningar.',
  'asset.automationApprovalFailed': 'Tillgången registrerades, men automatisk månadsbokföring kunde inte aktiveras. Kontrollera status på tillgångssidan.',
  'asset.autoPostingActive': 'Automatisk månadsbokföring är standard',
  'asset.monthlyDepreciationPreview': 'Den redovisningsmässiga avskrivningen blir ungefär {amount} per månad och bokförs automatiskt efter registrering.',
  'asset.monthlyDepreciationPreviewOff': 'Automatisk månadsbokföring är avaktiverad under Inställningar – Bokföring.',
  'asset.manageInSettings': 'Hantera i inställningar',
  'asset.special.financing': 'Lån och finansiering',
  'asset.special.tradeIn': 'Inbyte',
  'asset.special.partialSale': 'Delförsäljning',
  'asset.special.property': 'Fast egendom',
  'asset.specialCasesHelp': 'Praktisk vägledning för situationer som kräver särskild dokumentation eller uppdelning.',
  'asset.automationStopNote': 'Automatisk månatlig bokföring stoppad av användaren.',
  'asset.unpostedDepreciation': 'Återstår att bokföra: {amount} till och med {date}.',
  'asset.importedHistory': 'Importerad historik',
  'asset.importedHistoryHelp': 'Historisk tillgång importerad från ett annat bokföringssystem. Värden och avskrivningar visas från importspåret och bokförs inte på nytt i Plumme.',
  'asset.edit': 'Redigera tillgång',
  'asset.registerSold': 'Registrera som såld',
  'asset.moreOptions': 'Fler val',
  'asset.reclassifyPurchase': 'Gör om till vanligt inköp',
  'asset.reclassifyTitle': 'Gör om till vanligt inköp',
  "asset.acquisitionLockedTitle": "Varför är åtgärderna spärrade?",
  "asset.acquisitionLockedSold": "Tillgången är såld. Återför försäljningen innan köpet korrigeras.",
  "asset.acquisitionLockedReview": "Stäm av bokföringen innan köpet korrigeras.",
  "asset.acquisitionLockedDepreciation": "Tillgången har bokförda avskrivningar. Köpet och tillgången kan inte ändras eller tas bort direkt. Använd korrigeringen nedan om köpet skulle ha kostnadsförts. Om själva köpet är fel krävs spårbara motbokningar av avskrivningar och köp.",
  "asset.correctCapitalization": "Korrigera felaktig aktivering",
  "asset.correctCapitalizationBody": "Använd detta endast när köpet är korrekt men skulle ha kostnadsförts. Avskrivningarna återförs och anskaffningsvärdet flyttas till valt kostnadskonto i en sparning. Originalverifikationer, moms och betalningar bevaras. Välj ett datum efter senaste avskrivningen inom samma öppna år. Gruppavskrivningar och nedskrivningar kräver särskild granskning.",
  'asset.reclassifyBody': 'Använd detta när inköpet är korrekt, men inte skulle ha registrerats som tillgång. Verifikationen behålls, och konteringen flyttas från tillgångskontot till valt kostnadskonto.',
  'asset.expenseAccount': 'Kostnadskonto',
  'asset.correctionReason': 'Orsak',
  'asset.correctionReasonPh': 'T.ex. under beloppsgränsen / fel klassificering',
  'asset.reclassifiedToast': 'Inköpet har gjorts om till ett vanligt inköp.',
  'asset.reclassifyError': 'Kunde inte göra om tillgången till ett vanligt inköp.',
  'asset.annulPurchase': 'Makulera inköpsverifikation',
  'asset.annulTitle': 'Makulera inköpsverifikation',
  'asset.annulBody': 'Använd detta när hela inköpsverifikationen är fel eller dubbelbokförd. Verifikationen raderas inte från historiken, men bokföringen tas bort från rapporter och råbalans.',
  'asset.annulLocksTitle': 'Kan vara låst av moms, bank eller bokslut',
  'asset.annulLocksBody': 'Om perioden är inlämnad, bankavstämd eller bokslutad måste den öppnas eller korrigeras innan verifikationen kan makuleras.',
  'asset.annulReasonPh': 'T.ex. dubbelbokförd verifikation / fel uppladdning',
  'asset.annulledToast': 'Inköpsverifikationen har annullerats.',
  'asset.annulError': 'Det gick inte att annullera inköpsverifikationen.',
  'asset.markMistaken': 'Markera tillgången som felregistrerad',
  'asset.saleDate': 'Försäljningsdatum',
  'asset.bookValueShort': 'Bokfört värde',
  'asset.saleAmountExVat': 'Försäljningsbelopp exkl. moms',
  'asset.vat': 'Moms',
  'asset.howRegisterSale': 'Hur vill du registrera försäljningen?',
  'asset.continueTitle': 'Fortsätta?',
  'asset.continue': 'Fortsätt',
  'asset.undoDeleteTitle': 'Ångra borttagning?',
  'asset.undoDelete': 'Ångra borttagning',
  'asset.undoSaleTitle': 'Ångra försäljning?',
  'asset.undoSale': 'Ångra försäljning',
  'asset.saveDraft': 'Spara utkast',
  'asset.name': 'Namn på inventarie',
  'asset.namePh': 'T.ex. MacBook Pro 16"',
  'asset.depreciationNote': 'Det här inköpet registreras som inventarie och skrivs av vid bokslutet.',
  'asset.supplierPurchase': 'Leverantörsinköp',
  'asset.supplier': 'Leverantör',
  'asset.invoiceNumber': 'Fakturanummer',
  'asset.invoiceNumberPh': 'T.ex. 100245',
  'asset.lines': 'Rader',
  'asset.linePh': 'T.ex. maskin, dator eller verktyg',
  'asset.account': 'Inventariekonto',
  'asset.vatRate': 'Momssats',
  'asset.addLine': 'Lägg till rad',
  'asset.paidBy': 'Betalt av',
  'asset.payOperating': 'Företagskonto - 1920',
  'asset.payCash': 'Kontant - 1900',
  'asset.payPrivate': 'Privat - 2060',
  'asset.payLoan': 'Betalt genom upptaget lån - 2250',
  'asset.splitPayment': 'Dela upp betalningen',
  'asset.partPayments': 'Delbetalningar',
  'asset.fullPayment': 'Full betalning',
  'asset.addPartPayment': 'Lägg till delbetalning',
  'asset.uploadFile': 'Ladda upp fil',
  'asset.dropFiles': 'Dra och släpp filer här, eller välj från datorn.',
  'asset.removeAttachment': 'Ta bort bilaga',
  'asset.sold': 'Såld',
  'asset.depreciated': 'Avskriven',
  'asset.active': 'Aktiv',
  'asset.viewsTitle': 'Vyer',
  'asset.viewsHelp': 'Filtrera listan: ”Aktiva” är tillgångar med kvarvarande bokfört värde som fortfarande skrivs av, ”Avskrivna” är helt nedskrivna till 0, ”Sålda” är avyttrade och ”Alla” visar allt.',
  'asset.noneInView': 'Inga tillgångar i den här vyn ännu',
  'asset.fromPurchase': 'Registrera från ett inköp',
  'asset.group': 'Grupp',
  'asset.groupHelp': 'Saldogruppen avgör avskrivningssatsen — hur stor andel som får skrivas av skattemässigt varje år. T.ex. grupp C (varubilar) och grupp D (maskiner, inventarier) har olika satser fastställda av Skatteetaten.',
  'asset.depreciatedHelp': 'Summan som har kostnadsförts hittills — alltså hur mycket av anskaffningsvärdet som redan har skrivits av under åren. Anskaffningsvärde minus avskrivet ger bokfört värde.',
  'asset.bookValue': 'Bokfört värde',
  'asset.bookValueHelp': 'Tillgångens kvarvarande värde i bokföringen nu — anskaffningsvärde minus det som har skrivits av. Det här är beloppet som återstår att skriva av under kommande år.',
  'asset.declining': 'Saldoavskrivning och blanketter',
  'asset.decliningHelp': 'Saldoavskrivning är den vanligaste avskrivningsmetoden: varje år skrivs en fast procentsats av kvarvarande saldo per grupp av. Tabellen visar underlaget per saldogrupp. RF-1084 och RF-1217 är Skatteetatens blanketter för avskrivning och temporära skillnader — Plumme fyller i dem utifrån siffrorna här.',
  'asset.opening': 'Ingående',
  'asset.additions': 'Nyanskaffningar',
  'asset.disposals': 'Försäljning',
  'asset.movements': 'Rörelser',
  'asset.depreciation': 'Avskrivning',
  'asset.closing': 'Utgående saldo',
  'asset.groupDFallback': 'Saldogrupp d - personbilar, maskiner och inventarier',
  'asset.attachmentFallback': 'Bilaga',
  'asset.pageTitleHelp': 'Tillgångar (inventarier) är större saker som företaget äger och använder i flera år — dator, fordon, maskiner, inventarier. De kostnadsförs inte direkt utan skrivs av: kostnaden fördelas lite varje år över livslängden. Här håller Plumme koll på avskrivning och blankettvärden åt dig.',
  'asset.pageAddHelp': 'Registrera en ny tillgång när en inventarie har ett anskaffningsvärde på minst 30 000 kr och en förväntad användningstid på minst tre år. Gränsen gäller inte bara fakturasumman.',
  'asset.emptyText': 'Tillgångar är saker som företaget äger och använder i flera år — som en dator, ett fordon eller verktyg. De skrivs av lite varje år. Registrera en tillgång från ett inköp, så håller vi koll på avskrivning och blankettvärden åt dig.',
  'asset.tabActive': 'Aktiva ({n})',
  'asset.tabDepreciated': 'Avskrivna ({n})',
  'asset.tabSold': 'Sålda ({n})',
  'asset.tabAll': 'Alla ({n})',
  'asset.colAsset': 'Tillgång',
  'asset.soldOnLabel': 'såld {date}',
  'asset.acquiredInline': 'Anskaffad {date}',
  'asset.groupRateInline': 'Grupp {group} · {rate} %',
  'asset.colAcquired': 'Anskaffad',
  'asset.colCost': 'Anskaffningsvärde',
  'asset.costInline': 'Anskaffningsvärde {amount}',
  'asset.colStatus': 'Status',
  'asset.decliningDescription': 'Underlag för saldoavskrivning per grupp. RF-1084 / RF-1217 visas som blankettreferenser för norsk skattelogik.',
  'asset.depreciationInline': 'Avskrivning −{amount}',
  'asset.atYearEnd': 'Vid utgången av {year}',
  'asset.accountingValue': 'Bokföringsmässigt värde',
  'asset.taxValue': 'Skattemässigt värde',
  'asset.temporaryDifference': 'Temporär skillnad',
  'asset.noCustomer': 'Utan kund',
  'asset.fallbackNoun': 'tillgång',
  'asset.saleLineDescription': 'Försäljning av {name}',
  'asset.deletedStatus': 'Borttagen',
  'asset.updateFailed': 'Det gick inte att uppdatera tillgången.',
  'asset.transitionSaved': 'Övergångsvärden och bedömning har sparats.',
  'asset.transitionSaveFailed': 'Det gick inte att spara övergångsvärdena.',
  'asset.soldPendingOther': 'Slutför Annan försäljning för att registrera tillgången som såld',
  'asset.soldPendingInvoice': 'Skapa fakturan för att registrera tillgången som såld',
  'asset.registeredSold': 'Tillgången registrerad som såld',
  'asset.detailTitle': 'Tillgång: {name}',
  'asset.tabInfo': 'Information',
  'asset.tabDepreciationChanges': 'Avskrivning / ändringar',
  'asset.tabForms': 'Blanketter',
  'asset.purchaseDate': 'Inköpsdatum',
  'asset.purchasePrice': 'Inköpspris',
  'asset.assetAccountLabel': 'Tillgångskonto',
  'asset.missingValue': 'Saknas',
  'asset.usefulLifeLabel': 'Ekonomisk livslängd',
  'asset.yearsCount': '{n} år',
  'asset.taxDepreciationRateLabel': 'Skattemässig avskrivningssats',
  'asset.impairmentAssessmentYear': 'Nedskrivningsprövning {year}',
  'asset.noIndicators': 'Inga indikatorer',
  'asset.impairedAmount': 'Nedskrivet {amount}',
  'asset.transitionHeading': 'Övergång till Plumme',
  'asset.transitionBody': 'Historiska bokförda värden behålls. Registrera ett separat skattemässigt ingångsvärde och en fackmässig plan för kommande bokslut.',
  'asset.registerTransitionValues': 'Registrera övergångsvärden',
  'asset.colYear': 'År',
  'asset.colType': 'Typ',
  'asset.colDescription': 'Beskrivning',
  'asset.colAccountingChange': 'Bokföringsmässig ändring',
  'asset.colNewValue': 'Nytt värde',
  'asset.sellTitle': 'Registrera tillgång som såld: {name}',
  'asset.sellNoInvoice': 'Registrera försäljning utan faktura',
  'asset.createInvoiceBtn': 'Skapa faktura',
  'asset.markSoldBtn': 'Markera som såld',
  'asset.gainOnSale': 'Vinst vid försäljning',
  'asset.lossOnSale': 'Förlust vid försäljning',
  'asset.sellMethodMarkDesc': 'Används när försäljningsintäkten redan är bokförd.',
  'asset.sellMethodOtherDesc': 'Öppnar Annan försäljning med tillgången förifylld.',
  'asset.sellMethodInvoiceDesc': 'Öppnar ett nytt fakturautkast med tillgången som rad.',
  'asset.sellHelperPrefix': 'Försäljningen minskar avskrivningssaldot i grupp {group}.',
  'asset.sellHelperMarkSuffix': 'Välj detta endast när intäkten redan är bokförd.',
  'asset.sellHelperOtherSuffix': 'Vi tar dig vidare för att bokföra själva försäljningsintäkten.',
  'asset.continueDeleteBody': 'Använd detta bara om tillgången registrerades av misstag och inte ska skrivas av. Utförda bokslut-/avskrivningsposter bör återföras innan tillgången markeras som borttagen.',
  'asset.markedDeleted': 'Tillgången markerad som borttagen',
  'asset.restoreDeleteBody': 'Det här gör tillgången aktiv igen och tar med den i saldogrupp, skattemässigt värde och avskrivningsunderlag. Om du har kört bokslut eller bokfört avskrivningar medan tillgången var borttagen bör dessa kontrolleras och eventuellt återföras innan du fortsätter.',
  'asset.deleteUndone': 'Borttagning ångrad',
  'asset.restoreSaleBody': 'Detta gör tillgången aktiv igen och tar bort försäljningen från saldogruppen och avskrivningsunderlaget. Det tar inte bort eller krediterar faktura eller annan försäljning som redan är registrerad i försäljningsflödet. Kontrollera bokslut och avskrivningsposter om de skapades efter att försäljningen registrerades.',
  'asset.saleUndone': 'Försäljning ångrad',
  'asset.transitionTitle': 'Övergångsvärden: {name}',
  'asset.saveAssessment': 'Spara bedömning',
  'asset.savingEllipsis': 'Sparar…',
  'asset.planStartLabel': 'Planstart i Plumme',
  'asset.remainingUsefulLifeYearsLabel': 'Återstående nyttjandeperiod (år)',
  'asset.taxOpeningValueYear': 'Skattemässigt ingående värde {year}',
  'asset.impairmentToBeRecordedShort': 'Nedskrivning registreras',
  'asset.impairmentAmountLabel': 'Nedskrivningsbelopp',
  'asset.documentationLabel': 'Dokumentation / motivering',
  'asset.importedHistoryUnchanged': 'Importerad historik ändras inte. Planen börjar med bokfört värde vid årets ingång och hålls åtskild från det skattemässiga värdet.',
  'asset.nameRequired': 'Namn på inventarie måste fyllas i.',
  'asset.amountMustBePositive': 'Beloppet måste vara större än 0.',
  'asset.planFieldsInvalid': 'Fyll i ett giltigt datum för färdigställande, nyttjandeperiod och restvärde.',
  'asset.assessImpairmentRequired': 'Bedöm tecken på värdenedgång för {year}.',
  'asset.impairmentAmountRequired': 'Ange nedskrivningsbeloppet.',
  'asset.draftContentRequired': 'Lägg till namn, rad eller bilaga innan du sparar utkastet.',
  'asset.updated': 'Tillgång uppdaterad',
  'asset.registeredDepreciating': 'Tillgång registrerad - skrivs av vid bokslut',
  'asset.saveFailed': 'Kunde inte spara tillgången.',
  'asset.attachmentAdded': 'Bilaga tillagd.',
  'asset.savingDots': 'Sparar...',
  'asset.registerAssetBtn': 'Registrera tillgång',
  'asset.bookDepreciationPanelTitle': 'Redovisningsmässig avskrivningsplan',
  'asset.bookDepreciationPanelDesc': 'Planen styr bokfört värde. Saldogruppen nedan används bara för skatt.',
  'asset.usefulLifeYearsFieldLabel': 'Nyttjandeperiod (år)',
  'asset.noImpairmentIndicatorsOption': 'Inga indikationer på värdenedgång',
  'asset.impairmentToBeRecordedOption': 'Nedskrivning ska registreras',
  'asset.documentationPlaceholder': 'Kort motivering eller hänvisning till dokumentation',
  'asset.supplierPurchaseHelp': 'Koppla tillgången till leverantör och fakturanummer när köpet kommer från en leverantörsfaktura.',
  'asset.noDescriptionFallback': 'Utan beskrivning',
  'asset.amountModeGross': 'inkl. moms',
  'asset.amountModeNet': 'exkl. moms',
  'asset.hideVoucher': 'Dölj verifikation',
  'asset.showVoucher': 'Visa verifikation',
  'asset.reclassAcct6540': 'Inventarier',
  'asset.reclassAcct7700': 'Övrig kostnad',
  'asset.missingFileLink': 'Fillänk saknas',
  'asset.cannotPreviewInBrowser': 'Kan inte förhandsgranskas i webbläsaren.',
  'asset.automaticPostingExplanation': 'Avskrivningar bokförs automatiskt för varje avslutad månad. Plumme tar igen saknade månader utan att du behöver göra något.',
  'asset.automaticPostingNeedsReview': 'Automatisk avskrivning behöver följas upp. Kontrollera tillgångens plan eller kontakta support. Plumme försöker igen när avvikelsen är åtgärdad.',
  'asset.automaticScopeUnsupported': 'Automatisk avskrivning stöds för närvarande bara för norska redovisningsupplägg som stöds.',
  'asset.automaticCorrectionRequired': 'Slutför korrigeringen av avskrivningsplanen efter återföringen. Därefter fortsätter den automatiska bokföringen.',
  'asset.automaticPostingThrough': 'Senast bokförda avskrivning: {date}.',
  'asset.automaticPostingPending': '{amount} återstår till och med {date}. Plumme följer upp bokföringen automatiskt.',
  'err.nativeValidation.fixedAssetAcquisitionRegistration.1': 'Välj en befintlig anskaffning som ska registreras.',
  'err.nativeValidation.fixedAssetAcquisitionRegistration.2': 'Anskaffningen är redan registrerad som inventarie.',
  'err.nativeValidation.fixedAssetAcquisitionRegistration.3': 'Registreringsdatumet måste stämma överens med den ursprungliga anskaffningen.',
});

window.PlummeI18n.register("sv", {
  "purchaseFlow.overview": "Inköpsöversikt",
  "purchaseFlow.search": "Sök inköp",
  "purchaseFlow.status": "Status",
  "purchaseFlow.all": "Alla",
  "purchaseFlow.empty": "Inga inköp hittades.",
  "purchaseFlow.creditNumber": "Kreditnotanummer",
  "purchaseFlow.creditNumberRequired": "Ange leverantörens kreditnotanummer.",
  "purchaseFlow.documents": "Bilagor",
  "purchaseFlow.original": "Ursprunglig faktura",
  "purchaseFlow.reverse": "Återför betalning",
  "purchaseFlow.reverseExplanation": "Hela betalningen återförs, även fördelningar till andra fakturor. Historiken bevaras.",
  "purchaseFlow.reason": "Orsak",
  "purchaseFlow.more": "Fler åtgärder"
});

window.PlummeI18n.register("sv", {"purchaseFlow.paymentTotal": "Hela betalningen: {amount}"});

window.PlummeI18n.register("sv", {
  "err.supplierPayment.selectionRequired": "Välj faktura för betalningen.",
  "err.supplierCredit.numberRequired": "Ange leverantörens kreditnotanummer.",
  "err.supplierCredit.conflict": "Kreditnotan stämmer inte med det sparade dokumentet.",
  "err.supplierCredit.duplicate": "Leverantörens kreditnotanummer är redan registrerat."
});

window.PlummeI18n.register("sv", {"purchaseFlow.purchase": "Inköp", "purchaseFlow.net": "Netto", "purchaseFlow.vat": "Moms"});

window.PlummeI18n.register("sv", {"asset.rename": "Byt namn"});



window.PlummeI18n.register("sv", {"asset.cancelDates": "K\u00f6pet fr\u00e5n {purchase} och tillh\u00f6rande bokningar motbokas {date}. Ursprungliga verifikationer och datum beh\u00e5lls.", "err.asset.cancelDetailsRequired": "Ange en anledning och anv\u00e4nd ett datum p\u00e5 eller efter ink\u00f6psdatumet.", "err.asset.laterChangesRequired": "St\u00e4m av senare tillg\u00e5ngs\u00e4ndringar eller avskrivningar utan entydig tillg\u00e5ng innan f\u00f6rs\u00e4ljningen registreras."});
